<template>
  <div class="view-wrapper this-wrapper">
    <div class="view">
      <v-toolbar class="my-bar">
        <v-btn v-if="rightFilter('w')" icon @click="add">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn v-if="rightFilter('d')" icon :disabled="!item" @click="dialogDelete = true">
          <v-icon>remove</v-icon>
        </v-btn>
        <v-btn v-if="rightFilter('w')" icon :disabled="!item" @click="addBlank">
          <v-icon>note_add</v-icon>
        </v-btn>
        <v-spacer />
        <ServiceHistory :item="item"></ServiceHistory>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline"
            >Вы точно хотите удалить услугу?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogDelete = false">Отмена</v-btn>
              <v-btn color="primary" text @click="deleteConfirm">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        show-select
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
        :item-class="itemColor"
        @click:row="rowClick"
      >
        <template v-slot:item.stateKey="{ item }">
          <v-icon v-if="item.stateKey === 'E'" color="green">done</v-icon>
          <v-icon v-else-if="item.stateKey === 'R'" color="blue"
          >arrow_right</v-icon
          >
          <v-icon v-else color="orange">arrow_left</v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-if="item" class="view">
      <v-toolbar class="my-bar">
<!--        <v-btn icon :disabled="!serviceDetail || !serviceDetail.valid" @click="save">
          <v-icon>save</v-icon>
        </v-btn>-->
        <SaveButton
        :additional-rules="!serviceDetail || !serviceDetail.valid"
        :handler="save"
        >

        </SaveButton>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <ServiceDetail :vm="this" :isReserve="true"></ServiceDetail>
    </div>
    <CheckLimit :vm="this"></CheckLimit>
  </div>
</template>

<script>
  import fetch from "@/utils/fetch";
  import vm2js from "@/utils/vm2js";
  import js2vm from "@/utils/js2vm";
  import ctx from "@/ctx";
  import dateLocalFilter from "../../filters/dateLocal.filter";
  import dateIsoFilter from "../../filters/dateIso.filter";
  import ServiceDetail from "./ServiceDetail";
  import moment from "moment";
  import CheckLimit from "../balance/Check";
  import rightFilter from "../../filters/right.filter";
  import ServiceHistory from "../invoices/ServiceHistory";
  import SaveButton from "@/components/ButtonFacade";

  let Item = function(d) {
    let self = this;

    d.visitDate = !d.visitDate ? new Date() : d.visitDate;
    d.postingDate = !d.postingDate ? new Date() : d.postingDate;
    d.quantity = !d.quantity ? 0 : d.quantity;
    d.amount = !d.amount ? 0 : d.amount;
    d.discountPercent = !d.discountPercent ? 0 : d.discountPercent;

    d.organization = d.organizationId;
    d.doctor = d.doctorId;
    d.diagnosis = d.diagnosisId;
    d.visitDate4List = d.visitDate;
    d.postingDate4List = d.postingDate;
    d.service = d.serviceId;
    d.serviceCategory = d.serviceCategoryId;

    self.organization2vm = function(val) {
      if (!val) return {};
      return ctx.src.org.first(val);
    };
    self.doctor2vm = function(val) {
      if (!val) return {};
      return ctx.src.doctors.get(val);
    };

    self.diagnosis2vm = function(val) {
      if (!val) return {};
      return ctx.src.diagnosis.get(val);
    };

    self.visitDate4List2vm = function(val) {
      return dateLocalFilter(val);
    };
    self.postingDate4List2vm = function(val) {
      return dateLocalFilter(val);
    };
    self.visitDate2vm = function(val) {
      return dateIsoFilter(val);
    };
    self.postingDate2vm = function(val) {
      return dateIsoFilter(val);
    };

    self.service2vm = function(val) {
      if (!val) return {};
      return ctx.src.services.get(val);
    };
    self.serviceCategory2vm = function(val) {
      if (!val) return {};
      return ctx.src.categories.get(val);
    };

    js2vm(self, d);
  };

  export default {
    props: {
      vm: Object
    },
    data: () => ({
      ctx,
      rightFilter,
      currentPage: 0,
      totalPages: 0,
      loading: false,
      selected: [],
      headers: [
        { text: "", value: "stateKey" },
        {
          text: "№",
          align: "start",
          sortable: false,
          value: "index"
        },
        {
          text: "Мед. учреждение",
          sortable: true,
          value: "organization.fullName"
        },
        { text: "Доктор", value: "doctor.fullName" },
        { text: "Дата введения", sortable: false, value: "postingDate4List" },
        { text: "Дата обращения", sortable: false, value: "visitDate4List" },
        { text: "Диагноз", sortable: false, value: "diagnosis.name" },
        { text: "Услуга", sortable: false, value: "service.name" },
        { text: "Категория", sortable: false, value: "serviceCategory.name" },
        { text: "Кол-во", sortable: false, value: "quantity" },
        { text: "% Скидка", sortable: false, value: "discountPercent" },
        { text: "Сумма", sortable: false, value: "amount" },
        { text: "Со скидкой", sortable: false, value: "discountedAmount" },
        { text: "Контрольный номер", sortable: false, value: "checkNumber" }
      ],
      items: [],
      item: undefined,
      dialog: false,
      dialogDelete: false,
      addItem: undefined,
      searchText: undefined,
      serviceDetail: undefined
    }),
    watch: {
      "vm.item": function(val) {
        this.selected = [];
        this.items = [];
        if (val) return this.fetchItems();
      },
      selected: function(val) {
        if (val.length === 0) this.item = undefined;
        else {
          this.item = new Item(vm2js(val[0]));
        }
      }
    },
    computed: {
      formTitle() {
        return this.addItem && !this.addItem.id
          ? "Новая запись"
          : "Редактирование записи";
      }
    },
    methods: {
      itemColor(item) {
        if (
          moment(item.visitDate) < moment(this.vm.item.startDate) ||
          moment(item.visitDate) > moment(this.vm.item.endDate)
        )
          return "item-red";
        return "";
      },
      add() {
        this.close();
        this.selected.push(new Item({ insuredId: this.vm.item.id }));
      },
      async addBlank() {
        const res = await fetch.post(
          "/api/accounting/referral-blank/save?invoiceServiceId=" + this.item.id
        );
        if (res && this.vm.blanksList)
          this.vm.blanksList.fetchItems()
      },
      async deleteConfirm() {
        const res = await fetch.post(
          "/api/accounting/invoices/delete-service?id=" + this.item.id
        );
        if (res) {
          this.selected = [];
          if (this.vm.refreshDetail) this.vm.refreshDetail();
          this.dialogDelete = false;
        }
      },
      async save() {
        let arr = [];
        let item = vm2js(this.item);
        if (item.id) {
          item.id = undefined;
          item.amount =
            item.amount - this.selected[0].amount;
          item.quantity = item.quantity - this.selected[0].quantity;
        }
        arr.push(item);
        this.limitCheck.setItem(item);
        await this.limitCheck.check(
          this.item.insuredId,
          this.item.serviceCategoryId,
          this.item.discountedAmount,
          this.item.quantity,
          this.item.id
        );
        const res = await fetch.post(
          "/api/accounting/invoices/save-service",
          vm2js(this.item)
        );
        if (res) {
          this.close();
          if (this.vm.refreshDetail) this.vm.refreshDetail();
        }
      },
      close() {
        this.selected = [];
      },
      async fetchItems() {
        this.items = [];
        this.loading = true;
        let res = await fetch.get(
          "/api/accounting/invoices/get-reserves-by-insured?insuredId=" +
          this.vm.item.id
        );
        if (res) {
          res.forEach(r => {
            this.items.push(new Item(r));
          });
        }
        this.loading = false;
      },
      rowClick(obj, row) {
        if (!row.isSelected) row.select(obj);
        else this.selected = [];
      }
    },
    mounted() {
      if (this.vm) this.vm.reservesList = this;
      this.fetchItems();
    },
    components: {
      SaveButton,
      ServiceDetail,
      CheckLimit,
      ServiceHistory
    }
  };
</script>

<style lang="scss" scoped>
  .this-wrapper {
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .this-wrapper::v-deep .v-data-table__wrapper {
    > table {
      counter-reset: section;
      tbody tr td:nth-child(3)::before {
        counter-increment: section;
        content: counter(section);
      }
    }
  }
</style>
